import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['parent', 'child']
  static values = { options: Object }

  connect() {
    this.refresh()
  }

  refresh() {
    const selectedKey = this.parentTarget.value
    const options = this.optionsValue[selectedKey] || []
    const enabled = selectedKey !== ''

    if (this.childTarget.tomselect) {
      this._refreshTomSelect(this.childTarget.tomselect, options, enabled)
    } else {
      this._refreshNativeSelect(options, enabled)
    }
  }

  _refreshTomSelect(tomSelect, options, enabled) {
    tomSelect.clear(true)
    tomSelect.clearOptions(() => false)
    tomSelect.addOptions(options.map(([label, value]) => ({ value: value, text: label })))
    tomSelect.refreshOptions(false)

    if (enabled) {
      tomSelect.enable()
    } else {
      tomSelect.disable()
    }
  }

  _refreshNativeSelect(options, enabled) {
    const placeholder = this.childTarget.querySelector('option[value=""]')
    const optionElements = options.map(([label, value]) => {
      const option = document.createElement('option')
      option.value = value
      option.textContent = label

      return option
    })

    this.childTarget.replaceChildren(...(placeholder ? [placeholder] : []), ...optionElements)
    this.childTarget.disabled = !enabled
  }
}
